import React, { PropsWithChildren } from 'react';

import Title from '@/components/Title';
import { ImageType } from '@/components/Image';
import {
  BlockWrapper,
  Card,
  ImageWrapper,
  ImageContent,
  CardInfo,
} from './ContactBlock.styles';

type Props = {
  image: ImageType;
  title: string;
};

const GenericBlock: React.FC<PropsWithChildren<Props>> = (props) => {
  const { image, title, children } = props;

  return (
    <BlockWrapper>
      <Card fillContainer>
        <ImageWrapper>
          <ImageContent {...image} />
        </ImageWrapper>
        <CardInfo>
          <Title size='lg' level='h3' margin='0 0 1rem'>
            {title}
          </Title>
          {children}
        </CardInfo>
      </Card>
    </BlockWrapper>
  );
};

export default GenericBlock;
